import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from "qs";
//接口url枚举
enum StatisticalEnumApi {
  WareToolStock_PAGE = "/WareToolStock/page", //分页查询工量具管理
  WareToolStock_EDIT = "/WareToolStock/edit", //更新
  WareToolStock_BORROW = "/WareToolStock/borrow", //借用
  WareToolStock_SCRAP = "/WareToolStock/scrap" //报废
}
//工量具管理 --- 列表
export function WareToolStockPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.WareToolStock_PAGE}?${qs.stringify(data)}`,
    data
  });
}

//工量具管理 -- 编辑
export function editWareToolStock(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolStock_EDIT,
    data
  });
}

//工量具管理 -- 借用
export function borrowWareToolStock(data: any) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolStock_BORROW,
    data
  });
}

//工量具管理 -- 报废
export function scrapWareToolHous(data: any) {
  return msiRequest.post<ResultType<any>>({
    url: `${StatisticalEnumApi.WareToolStock_SCRAP}`,
    data
  });
}
